module.exports = __webpack_public_path__ + "static/media/fridge.05aff56d.svg";